import { render } from "./BannerLeadsView.vue?vue&type=template&id=696df21d&scoped=true"
import script from "./BannerLeadsView.vue?vue&type=script&lang=js"
export * from "./BannerLeadsView.vue?vue&type=script&lang=js"

import "./BannerLeadsView.vue?vue&type=style&index=0&id=696df21d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696df21d"]])

export default __exports__